import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { PLACEMENT_ARROW } from "@/components/Swiper/SwiperWrapper";
import { StyledTagsSectionSlider } from "@/components/Tags/StyledTags";
import { getBreakpointMinWidth } from "@/styles/utils/Utils";
import { breakpoints } from "@/styles/utils/vars";
import { ButtonSliderArrow } from "@/ui/Button/StyledButton";
import { StyledProductsSlider, StyledProductsSliderInner } from "./Slider";
export const StyledProductPage = /*#__PURE__*/styled('div')({
  name: "StyledProductPage",
  class: "StyledProductPage_s1q7oqc5"
});
export const Side = /*#__PURE__*/styled('div')({
  name: "Side",
  class: "Side_s59fynl"
});
export const cssSideTitleRow = "cssSideTitleRow_c1yhqpor";

require("./StyledProductPage.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledProductPage.tsx");